import Client from "./Clients/AxiosClient";
const resource = "/api/v1/user/rapor";

export default {
  getBundles() {
    return Client.get(`${resource}/bundles`);
  },
  getRapor(bundleId) {
    return Client.get(`${resource}/${bundleId}`);
  },
};
